import { CONTENT_TYPE } from "../../../../../utils/constants";

export function makeStarterTemplate({ contentId, type }) {
    if (type === CONTENT_TYPE.LESSON) {
        return {
            id: contentId,
            schemaVersion: 1,
            type: "lesson",
            meta: {
                energyCost: 1,
            },
            fragments: [],
        };
    }

    if (type === CONTENT_TYPE.PROJECT) {
        return {
            id: contentId,
            schemaVersion: 1,
            type: "project",

            workspace: {
                type: "program",
                template: "python_beginner"
            },

            meta: {
                energyCost: 1
            },

            parts: []
        };
    }

    return null;
}
